import { render, staticRenderFns } from "./DigitalDetailGrid.vue?vue&type=template&id=6f56a3ef&scoped=true&"
import script from "./DigitalDetailGrid.vue?vue&type=script&lang=js&"
export * from "./DigitalDetailGrid.vue?vue&type=script&lang=js&"
import style0 from "./DigitalDetailGrid.vue?vue&type=style&index=0&id=6f56a3ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f56a3ef",
  null
  
)

export default component.exports